import { Text, VStack } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../../../../features/track';
import { urlBuilder } from '../../../../../Shared/urlBuilder';

type Props = {
  legacyGoalId: number;
  allocationDescription: string;
};

export const PortfolioAllocationRow: React.FC<Props> = ({ legacyGoalId, allocationDescription }) => (
  <VStack>
    <Text variant="text200">{allocationDescription}</Text>
    <SambaAutoLink
      to={urlBuilder.appGoalsEditAllocation.absolute({ goal_id: legacyGoalId, return_to: window.location.pathname })}
      onClick={() => {
        trackClick({
          name: 'EditPortfolioStrategyAllocation',
          flow: 'AccountOverview',
          location: 'PortfolioStrategyCard',
        });
      }}
      data-testid="allocation-change-link"
    >
      Edit
    </SambaAutoLink>
  </VStack>
);

export const ExternallyAdvisedPortfolioAllocationRow: React.FC<Props> = ({ legacyGoalId, allocationDescription }) => (
  <VStack>
    <Text variant="text200">{allocationDescription}</Text>
    <SambaAutoLink
      to={urlBuilder.appExternallyAdvisedPlan.absolute({ goalId: legacyGoalId, return_to: window.location.pathname })}
      onClick={() => {
        trackClick({ name: 'EditExternallyAdvisedPlan', flow: 'AccountOverview', location: 'PortfolioStrategyCard' });
      }}
    >
      Edit
    </SambaAutoLink>
  </VStack>
);
